import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../ui/dialog";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Label } from "../ui/label";
import { api, errMsg } from "../../lib/api";

export const RenewDialog = ({ row, onClose, onSaved }) => {
  const [nomor, setNomor] = useState("");
  const [tgl, setTgl] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (row) {
      setNomor(row.nomor_surat || "");
      setTgl("");
    }
  }, [row]);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.put(`/senpi/${row.item_id}/renew`, { nomor_surat: nomor, berlaku_sd: tgl });
      toast.success("Surat ijin senpi diperbarui");
      onSaved();
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={!!row} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="rounded-sm" data-testid="renew-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">Perpanjang Surat Ijin Senpi</DialogTitle>
          <DialogDescription>
            {row?.pj_pangkat} {row?.pj_nama} &middot; {row?.merk_model} {row?.no_seri}
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="renew-nomor">Nomor Surat Ijin Baru *</Label>
            <Textarea id="renew-nomor" rows={2} required value={nomor} onChange={(e) => setNomor(e.target.value)} data-testid="renew-nomor-input" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="renew-tgl">Berlaku Sampai Dengan *</Label>
            <Input id="renew-tgl" type="date" required value={tgl} onChange={(e) => setTgl(e.target.value)} data-testid="renew-date-input" />
            <p className="text-xs text-muted-foreground">Sebelumnya: {row?.berlaku_sd || "-"}</p>
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose} data-testid="renew-cancel">Batal</Button>
            <Button type="submit" disabled={saving} data-testid="renew-submit">
              {saving && <Loader2 className="h-4 w-4 animate-spin" />} Simpan Perpanjangan
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
